<template>
	<v-app>
		<v-navigation-drawer v-if="isNotIphone" v-model="drawer" app right>
			<v-card flat>
				<v-card-title>{{ $t("drawer.initialSettings") }}</v-card-title>
				<v-card-text class="py-0">
					<v-switch v-model="autoPlay" inset :label="$t('drawer.autoPlayLabel')" />
				</v-card-text>
				<v-card-text class="py-0">
					<v-switch v-model="alwaysShowControls" inset :label="$t('drawer.showControlsLabel')" />
				</v-card-text>
				<v-card-text class="py-0">
					<v-text-field v-model="startPosition" @keypress="isNumericChar" maxlength="5" :label="$t('drawer.startPositionLabel')" :placeholder="$t('drawer.startPositionPlaceholder')" />
				</v-card-text>
				<v-card-text class="py-0">
					<v-select v-model="startResolution" :items="resolutions" :label="$t('drawer.startResolutionLabel')" />
				</v-card-text>
			</v-card>
		</v-navigation-drawer>
		<v-app-bar app color="primary" dark>

			<v-toolbar-title>{{ $t("windowTitle") }}</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-app-bar-nav-icon v-if="isNotIphone" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

		</v-app-bar>
		<v-main>
			<v-container fluid>
				<v-row>
					<v-col cols="12" sm="10">
						<v-text-field v-model.trim="inputStream" :label="$t('ui.inputStreamLabel')" :placeholder="$t('ui.inputStreamPlaceholder')" clearable hide-details />
					</v-col>
					<v-col cols="12" sm="2">
						<v-btn @click="onLoad" large color="primary" width="100%">{{ $t("ui.loadBtn") }}</v-btn>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<div v-if="this.videoUrl" class="wrapper" :class="{ wrapperSmall: $vuetify.breakpoint.smAndDown }">
							<VideoPlayer ref="videoPlayerComponent" :key="videoPlayerKey" :url="this.videoUrl" :autoPlay="this.autoPlay" :showControls="this.alwaysShowControls" :start="this.startPosition" :resolution="this.startResolution" />
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'

export default {
	name: 'App',

	metaInfo: {
		meta: [
			{ name: 'robots', content: 'noindex' }
		]
	},

	components: {
		VideoPlayer,
	},

	data: () => ({
		alwaysShowControls: false,
		autoPlay: false,
		drawer: null,
		inputStream: null,
		resolutions: [ "1080p", "720p", "480p", "Auto" ],
		startPosition: "0",
		startResolution: "480p",
		videoPlayerKey: 0,
		videoUrl: null
	}),

	computed: {
		isNotIphone() {
			return !this.$root.device.iphone;
		}
	},

	methods: {
		getCharCode(e) {
			// in the keypress event, all browsers except IE <= 8 store the character code in the event's which property
			var charCode = (typeof e.which == "number") ? e.which : e.keyCode;
			
			return charCode;
		},
		isNumericChar(e) {
			var charCode = this.getCharCode(e);
			
			// only accept numeric characters
			if(charCode >= 32 && charCode < 48)
				e.preventDefault();
			else if(charCode != 127 && charCode > 57)
				e.preventDefault();
		},
		onLoad() {
			// this.$refs.videoPlayerComponent.update(this.inputStream, this.autoPlay, this.alwaysShowControls, this.startPosition, this.startResolution);
			this.videoUrl = this.inputStream;
			this.videoPlayerKey += 1;
		}
	}
};
</script>

<style scoped>

	.wrapper {
		background-color: #000000;
		color: #ffffff;
		height: 480px;
		width: 854px;
	}

	.wrapperSmall {
		height: auto;
		min-height: 200px;
		width: 100%;
	}

</style>
